export const resources = {
  ShowDescription: '',
  ReadMore: '',
  DescriptionCollapsed: '',
  DescriptionBioExpanded: ''
};
